$(function () {
  Foundation.addToJquery($);

  // setTimeout(function(){
  //     $('#news-entries').foundation();
  photoModals();
  // }, 500);

  if (totalPages < page) {
    $("#loadMore").hide();
    $(".module-news__loader").removeClass("module-news__loader--active");
  }

  var ajaxRan = false;
  $("#loadMore").click(function (e) {
    e.preventDefault();
    $("#loader").show();
    $(".module-news__loader").addClass("module-news__loader--active");

    $.get("/" + segment + "/p" + page + "?" + query, function (data) {
      $("#news-entries").append(data);
      $("#loader").hide();
      $(".module-news__loader").removeClass("module-news__loader--active");
      ajaxRan = true;
      $("#news-entries").trigger("entriesLoaded");

      page++;

      if (totalPages < page) {
        $("#loadMore").hide();
        $(".module-news__loader").removeClass("module-news__loader--active");
      }
    });

    $("#news-entries.gallery-entries").on("entriesLoaded", function () {
      // setTimeout(function(){
      //     $('#news-entries').foundation();
      photoModals();
      // }, 500);
    });
  });

  // //close modal
  // $('.close-button').on('click', function () {
  //   $(this).closest('.reveal-overlay').foundation('close');
  // });

  function photoModals() {
    // on click open popup
    var entryIds = [];
    var prevId = null;
    var nextId = null;
    var id = null;

    // unbind and rebind click event
    $(".gallery-entries .module-news__content-article-link")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();

        entryIds = [];
        id = $(this).attr("id");

        $("div[id*=galleryModal-" + id + "]").each(function () {
          entryIds.push($(this).attr("id"));
        });
        if (entryIds.length) {
          //$('#' + entryIds[0]).foundation('open');
          let $reveal1 = new Foundation.Reveal($("#" + entryIds[0]));

          $reveal1.open();

          //if close-button is clicked, close all modals
          $(".close-button").on("click", function () {
            $reveal1.close();
          });
        }
      });

    // fires before click open popup
    // unbind and rebind close event
    $("body")
      .off("closeme.zf.reveal")
      .on("closeme.zf.reveal", function (e) {
        var currentIndex = null;
        $.each(entryIds, function (i, val) {
          if (val == e.target.id) {
            currentIndex = i + 1;
            prevId = entryIds[i - 1]
              ? entryIds[i - 1]
              : entryIds[entryIds.length - 1];
            nextId = entryIds[i + 1] ? entryIds[i + 1] : entryIds[0];
          }
        });
      });

    // modal navigation
    // unbind and rebind click events
    $('div[id*="galleryModal-"] .orbit-previous')
      .off("click")
      .on("click", function () {
  
        id = prevId;
        let $reveal2 = new Foundation.Reveal($("#" + prevId));
        
        $reveal2.open();
        //if close-button is clicked, close all modals
        $(".close-button").on("click", function () {
          $reveal2.close();
        });
      });

    $('div[id*="galleryModal-"] .orbit-next')
      .off("click")
      .on("click", function () {
        
        id = nextId;
        
        let $reveal3 = new Foundation.Reveal($("#" + nextId));
        //close previous modal
        
        $reveal3.open();
        //if close-button is clicked, close all modals
        $(".close-button").on("click", function () {
          $reveal3.close();
        });
      });
  }
  $(document).on('closed.zf.reveal', '[data-reveal]', function() {
    //console.log('close reveal');
    $('.reveal-overlay').css('display', 'none');
  });
});